module.exports = __webpack_public_path__ + "images/stickers/warning@2x.a678b1f2e6242bc1d31a.png";